import axios from "axios";
import store from "../store";

const max_requests = 3;
var pending_requests = 0;

function setup() {
    axios.interceptors.response.use(
        function (config) {
            console.log("trying to do stuff...")
            const token = store.state.accessToken;
            if (token) {
                pending_requests = 0;
                config.headers.Authorization = `Bearer ${token}`;
            }
            return config;
        },
        function (err) {
            console.log("error thrown...")
            const token = store.state.refreshToken;
            const originalRequest = err.config;

            try {
                if (!err.response) {
                    return Promise.reject({
                        message: "Cannot connect to Server",
                        code: 408,
                    });
                }
            } catch (e) {
                console.log("handling no response from server failed..", e);
            }

            console.log("teste code", err.response.data)
            if (err.response.data.detail == "Unpermitted") {
                return Promise.reject(err);
            }

            // Reject promise if usual error
            if (
                token &&
                err.response &&
                ((err.response.data.detail == "Authentication credentials were not provided.") ||
                    err.response.data.code == "token_not_valid" || err.response.data.type == "application/json") &&
                err.response.status == 403 &&
                pending_requests < max_requests
            ) {
                pending_requests++;
                console.log("success")
                return store.dispatch("refreshToken").then(() => {
                    originalRequest._retry = true;
                    originalRequest.headers["Authorization"] =
                        "Bearer " + store.state.accessToken;
                    return axios(originalRequest);
                });
            }

            // window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: err }));

            return Promise.reject(err);
        }
    );
}

export default setup;
